import React from "react"
import { useLocale, useAppContext } from "hooks"
import { useUser } from "lib/user"
import { duplicateRafRedemptionModalVar } from "lib/apollo/variables/uxVars"
import { useReactiveVar } from "@apollo/client"
import { Modal } from "packages/acquisition/shared/components/Modal/Modal"
import {
  membersModalContainer,
  nonMembersModalContainer,
  membersContentContainer,
  contentContainer,
  title,
  bodyText,
  buttonContainer,
  bodyContainer,
  linkContainer,
} from "./DuplicateRafRedemptionModal.css"
import { BPLink } from "packages/ui-shared/components/Link/Link"
import { Button } from "packages/ui-shared/components/Button/Button"

export const DuplicateRafRedemptionModal: React.FC = () => {
  const user = useUser()
  const locale = useLocale()
  const { currencySymbol } = useAppContext()
  const showModal = useReactiveVar(duplicateRafRedemptionModalVar)
  const onClose = () => duplicateRafRedemptionModalVar(false)

  return (
    <Modal isOpen={showModal} onClose={onClose} title="Sorry!">
      {user.isMember ? (
        <div
          data-testid="MembersRedemptionModal"
          className={membersModalContainer}
        >
          <div className={membersContentContainer}>
            <h2 id="dialog-title" className={title}>
              Sorry!
            </h2>
            <div className={bodyContainer}>
              <p data-testid="RedemptionModalBodyText" className={bodyText}>
                You've already used your {currencySymbol}
                {locale === "en-GB" ? "10" : "20"} off referral reward credit.
                Share your unique Refer-A-Friend link with more loved ones, to
                increase your chances of receiving more credits in the future!
              </p>
              <div className={buttonContainer}>
                <BPLink href="/bp/join/join-beauty-pie">
                  <Button
                    data-testid="ReferAFriendButton"
                    fullWidth
                    variant="primary"
                  >
                    Refer a Friend
                  </Button>
                </BPLink>
                <Button
                  data-testid="ContinueShoppingButton"
                  variant="tertiary"
                  handleClick={(e) => {
                    e?.preventDefault()
                    onClose()
                  }}
                >
                  Continue shopping
                </Button>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div
          data-testid="NonMembersRedemptionModal"
          className={nonMembersModalContainer}
        >
          <div className={contentContainer}>
            <h2 id="dialog-title" className={title}>
              Sorry!
            </h2>
            <div className={bodyContainer}>
              <p data-testid="RedemptionModalBodyText" className={bodyText}>
                You've already used your {currencySymbol}
                {locale === "en-GB" ? "10" : "20"} off referral link. Loved your
                Beauty Pie products? Go to our Join Now page and choose from one
                of our memberships to get more savings.
              </p>

              <BPLink href="/bp/join/join-beauty-pie" className={linkContainer}>
                <Button variant="primary" fullWidth={true}>
                  Join Now
                </Button>
              </BPLink>
            </div>
          </div>
        </div>
      )}
    </Modal>
  )
}
